<span [cerrixHover]="instructionText ? hoverCard : null" class="cerrix-instructions-icon">
    <mat-icon svgIcon="instructions"></mat-icon>
    @if (showText) {
        <span>Instructions</span>
    }
    <ng-template #hoverCard>
        {{ instructionText }}
    </ng-template>
</span>
